import { useContext } from 'react';

import { MovimentacaoFundosContext } from '../contexts/MovimentacaoFundosContext';

export const useMovimentacaoFundos = () => {
  const context = useContext(MovimentacaoFundosContext);
  if (context === undefined) {
    throw new Error(
      'useMovimentacaoFundos necessita ser utilizado dentro de MovimentacaoFundosProvider'
    );
  }
  return context;
};
